function domReady(fnc) {
	document.addEventListener("DOMContentLoaded", fnc);
}

domReady(() => {
	document.addEventListener("ds:variant-selected", () => refreshWarehouseSeparateSelect());
});

function warehouseRadio() {
	const warehouseOptions = document.querySelectorAll(".js-warehouse-option");
	const availableNotification = document.querySelector(
		".js-warehouse-available-notification",
	);

	if (window.customer.currency !== 'USD') return;
	
	for (const option of warehouseOptions) {
		option.addEventListener("click", () => {
			handleWarehouseClick(
				option,
				warehouseOptions,
				availableNotification,
      );
		});
	}
}
domReady(warehouseRadio);

function handleWarehouseClick(target, options, notification) {
  if (target.classList.contains("option-selected")) return;
	// Style update
	for (const option of options) {
		option.classList.remove("option-selected");
		option
			.querySelector(".js-warehouse-radio")
			?.classList.remove("warehouse-selected");
		option.querySelector(".js-warehouse-radio")?.removeAttribute("checked");
	}
	target.classList.add("option-selected");
	target
		.querySelector(".js-warehouse-radio")
		?.classList.add("warehouse-selected");
  target.querySelector(".js-warehouse-radio")?.setAttribute("checked", true);

	// In stock available notification and count update
  const inStockRow = target.querySelector(".js-availability-in-stock");
	if (inStockRow) {
		if (!notification.classList.contains("hidden")) {
			notification.classList.add("hidden");
		}
	} else {
		notification.classList.remove("hidden");
	}
}

let warehouseSeparateClicksDelegated = false;

function bindWarehouseSeparateClicksOnce() {
	const availabilityAccordion = document.getElementById("availability-accordion");

	if (!availabilityAccordion || warehouseSeparateClicksDelegated) return;

	availabilityAccordion.addEventListener("click", (event) => {
		const warehouse = event.target.closest(
			".warehouse-select-location-options-container",
		);
		if (
			!warehouse ||
			!warehouse.closest("#warehouse-location-select-details")
		)
			return;
		handleClick(event, warehouse);
	});

	warehouseSeparateClicksDelegated = true;
}

function refreshWarehouseSeparateSelect() {
	const warehouseSeparateSelect = document.getElementById(
		"warehouse-location-select-details",
	);

	const warehouseAccordionRoot = warehouseSeparateSelect?.parentElement;
	if (
		!warehouseAccordionRoot?.classList?.contains("warehouse-accordion")
	) {
		return;
	}

	updateWarehouseRelatedDisplay(warehouseSeparateSelect.dataset.selectedWarehouse);
}

function initWarehouseSeparateSelect() {
	bindWarehouseSeparateClicksOnce();
	refreshWarehouseSeparateSelect();
}

domReady(initWarehouseSeparateSelect);

function updateWarehouseRelatedDisplay(location) {
	const currentLocationRaw = getCurrentWarehouse(location);
	const currentLocation =
		currentLocationRaw != null ? String(currentLocationRaw).trim().toLowerCase() : "";

	const warehouseContainer = document.getElementById(
		"warehouse-location-select-details",
	);
	const warehouseDataRaw = warehouseContainer.dataset.warehouseStoreData ?? "";
	const warehouseData = warehouseDataRaw
		.split("?")
		.map((segment) => segment.trim())
		.filter(Boolean);

	const { regular: matchedVariantData, preorder: matchedPreorderVariantData } =
		findMatchingVariants(warehouseData);

	// Update warehouse selection visibility
	const hasMatchedVariants =
		matchedVariantData !== "" || matchedPreorderVariantData !== "";
	updateWarehouseVisibility(warehouseContainer, hasMatchedVariants);

	// When warehouse selection is displayed
	if (!hasMatchedVariants) return;

	if (matchedVariantData || matchedPreorderVariantData) {
		updateAvailabilityTables(matchedVariantData, matchedPreorderVariantData);
	}

	if (matchedVariantData) {
		updateWarehouseAvailabilityNotification(matchedVariantData, currentLocation);
	}

	if (matchedVariantData || matchedPreorderVariantData) {
		updateQuantityAndCartButton(
			matchedVariantData,
			matchedPreorderVariantData,
			currentLocation,
		);
	}
}

const findMatchingVariants = (warehouseData) => {
	const currentOptions = getCurrentVariantOptions();

	if (!currentOptions) return { regular: "", preorder: "" };

	return warehouseData
		.map((segment) => segment.trim())
		.filter(Boolean)
		.reduce(
		(matches, variant) => {
			const bang = variant.indexOf("!");
			const options =
				bang === -1 ? variant.trim() : variant.slice(0, bang).trim();
			const data = bang === -1 ? "" : variant.slice(bang + 1);
			if (!options) return matches;

			if (isPreorderVariant(options)) {
				return handlePreorderVariant(options, data, currentOptions, matches);
			}
			return handleRegularVariant(options, data, currentOptions, matches);
		},
			{ regular: "", preorder: "" },
		);
};

const updateWarehouseVisibility = (container, hasMatchedVariants) => {
	const parent = container.parentElement;
	const classesToRemove = [
		"warehouse-selection__displayed",
		"warehouse-selection__hidden",
		"hidden",
	];

  for (const className of classesToRemove) {
    parent.classList.remove(className)
  }

	const visibilityClass = hasMatchedVariants
		? "warehouse-selection__displayed"
		: "warehouse-selection__hidden";

	parent.classList.add(visibilityClass);
};

const updateAvailabilityTables = (
	matchedVariantData,
	matchedPreorderVariantData,
) => {
	const tables = document.querySelectorAll(".product__availability-container");

	for (const table of tables) {
		const warehouseLocation = (table.dataset.warehouseLocation ?? "")
			.trim()
			.toLowerCase();
		table.innerHTML = "";

		const regularRows = getRegularInventoryRows(
			matchedVariantData,
			warehouseLocation,
		);
		const preorderRows = getPreorderInventoryRows(
			matchedPreorderVariantData,
			warehouseLocation,
		);
		const rows = [...regularRows, ...preorderRows];

		if (rows.length === 0) {
			table.innerHTML = createUnavailableRow();
		} else {
			table.innerHTML = rows.join("");
		}
	}
};

const updateWarehouseAvailabilityNotification = (
	matchedVariantData,
	currentLocation,
) => {
	const { notification, notificationText } = updateWarehouseNotification();

	if (!matchedVariantData) return;

	let warehouseList = "";
	const matchedVariantDataArray = matchedVariantData
		.split(",")
		.map((s) => s.trim())
		.filter(Boolean);
	let currentWarehouseInventoryZero = false;
	let anotherWarehouseInventoryZero = true;
	for (const locationData of matchedVariantDataArray) {
		const parts = locationData.split("|").map((p) => p.trim());
		const [inventory, , locationRaw] = parts;
		const warehouseLocation = locationRaw?.toLowerCase?.() ?? "";

		if (
			warehouseLocation ===
			(currentLocation ?? "").trim().toLowerCase()
		) {
			const currentInventory = Number.parseInt(inventory);

			currentWarehouseInventoryZero = currentInventory === 0
		} else {
			const otherInventory = Number.parseInt(inventory);
			if (otherInventory > 0) {
				const capitalizedLocation = `${warehouseLocation.charAt(0).toUpperCase()}${warehouseLocation.slice(1)}`;
				warehouseList += ` or ${capitalizedLocation}`;
				anotherWarehouseInventoryZero = false;
			}
		}

		if (
			notification &&
			currentWarehouseInventoryZero &&
			!anotherWarehouseInventoryZero
		) {
			const message = `Select ${warehouseList.slice(4)} Warehouse to check in-stock inventory`;
			notificationText.innerText = message
			notification.style.display = "block";
		} else {
			notification.style.display = "none";
		}
	}
};

const updateQuantityAndCartButton = (
	matchedVariantData,
	matchedPreorderVariantData,
	currentLocation,
) => {
	const quantityInput = document.querySelector(".quantity__input");
	if (!quantityInput) return;

	const { existInstockQuantity, existPreorderQuantity } =
		getExistingCartQuantities(quantityInput, currentLocation);

	const addToCartTextContainer = document.querySelector(
		".product-form__buttons button span",
	);
	const { inputAvailableValue, inputMaxValue } = calculateInputValues(
		matchedVariantData,
		matchedPreorderVariantData,
		currentLocation,
		existInstockQuantity,
		existPreorderQuantity,
		quantityInput,
	);

	updateCartButtonState(
		addToCartTextContainer,
		inputAvailableValue,
		inputMaxValue,
	);
};

function handleClick(event, warehouse) {
	event.stopPropagation();
	const warehouseContainer = document.getElementById(
		"warehouse-location-select-details",
	);
	const currentLocation = warehouseContainer?.dataset?.selectedWarehouse;
	const targetLocation =
		warehouse
			.querySelector(".warehouse-select-location-options.js-warehouse-radio")
			?.dataset?.warehouseLocation?.trim()
			?.toLowerCase() ??
		warehouse.dataset?.warehouseLocation?.trim()?.toLowerCase();

	if (
		targetLocation !== undefined &&
		targetLocation !== null &&
		String(currentLocation ?? "").trim().toLowerCase() !== targetLocation
	) {
      const newLocation = targetLocation;

      warehouseContainer?.setAttribute("data-selected-warehouse", newLocation);
      // Update related inventory displays and settings
      updateWarehouseRelatedDisplay(newLocation);

      document.dispatchEvent(
          new CustomEvent("warehouseUpdate", {
              detail: targetLocation,
              bubbles: true,
              composed: true,
          })
      )
  }
}

//////
// Helper Functions
/////

const getCurrentWarehouse = (location) => {
	if (location !== "unset") return location;

	const warehouseContainer = document.getElementById(
		"warehouse-location-select-details",
	);
	return warehouseContainer.dataset.selectedWarehouse;
};

const getCurrentVariantOptions = () => {
	const legendSelections = Array.from(
		document.querySelectorAll("legend.form__label span:not(.option-toggle)"),
	);
	if (legendSelections.length > 0) {
		return legendSelections.reduce((accumulator, span) => {
			const optionText = span.textContent.trim();
			return accumulator ? `${accumulator} / ${optionText}` : optionText;
		}, "");
	}

	const variantSelectsRoot = document.querySelector("variant-selects");
	const selectElements = variantSelectsRoot?.querySelectorAll(
		"select.select__select",
	);

	if (!selectElements?.length) return "";

	return Array.from(selectElements).reduce((accumulator, selectEl) => {
		const selectedText =
			selectEl.options[selectEl.selectedIndex]?.textContent.trim() ?? "";
		return accumulator
			? `${accumulator} / ${selectedText}`
			: selectedText;
	}, "");
};

const isPreorderVariant = (options) => options.includes(" (Preorder)");

const handlePreorderVariant = (options, data, currentOptions, matches) => {
	const cleanOptions = options.replace(/ \(Preorder\)/g, "");
	if (data && cleanOptions === currentOptions) {
		return { ...matches, preorder: data };
	}
	return matches;
};

const handleRegularVariant = (options, data, currentOptions, matches) => {
	if (data && options === currentOptions) {
		return { ...matches, regular: data };
	}
	return matches;
};

const getRegularInventoryRows = (variantData, targetLocation) => {
	if (!variantData) return [];

	return variantData
		.split(",")
		.map((raw) => raw.trim())
		.filter(Boolean)
		.map((data) => {
			const parts = data.split("|").map((p) => p.trim());
			const [quantity, , locationRaw] = parts;
			const location = locationRaw ?? "";
			if (location.toLowerCase() !== targetLocation || quantity === "0")
				return null;
			return `
        <tr class="product__availability-table-row js-availability-in-stock" data-available-count="${quantity}">
          <td class="product__availability-table-cell">${quantity}</td>
          <td class="product__availability-table-cell">In stock</td>
        </tr>
      `;
		})
		.filter(Boolean);
};

const getPreorderInventoryRows = (variantData, targetLocation) => {
	if (!variantData) return [];

	return variantData
		.split(",")
		.map((raw) => raw.trim())
		.filter(Boolean)
		.map((data) => {
			const parts = data.split("|").map((p) => p.trim());
			const [quantity, status, locationRaw] = parts;
			const location = locationRaw ?? "";
			if (location.toLowerCase() !== targetLocation) return "";

			return `
                <tr class="product__availability-table-row">
                    <td class="product__availability-table-cell">${quantity}</td>
                    <td class="product__availability-table-cell">${status}</td>
                </tr>
            `;
		})
		.filter(Boolean);
};

const createUnavailableRow = () => `
  <tr class="product__availability-table-row">
  	<td class="product__availability-table-cell">Currently Unavailable</td>
  </tr>
`;

const updateWarehouseNotification = () => {
  const notification = document.querySelector(".js-warehouse-available-notification")
  const notificationText = document.querySelector(".js-warehouse-available-notification-text")

  return { notification, notificationText }
}

const getExistingCartQuantities = (quantityInput, currentLocation) => {
	const cartLineItems = quantityInput.dataset.existCartItems;
	const currentSKU = document
		.querySelector(".product__sku")
		.innerText.replace("SKU: ", "");
	let existInstockQuantity = 0;
	let existPreorderQuantity = 0;

	if (!cartLineItems) return { existInstockQuantity, existPreorderQuantity };

	for (const cartLineItem of cartLineItems.split(",")) {
		const [sku, quantity, warehouse] = cartLineItem.split("|");

		if (
			sku.includes(currentSKU) &&
			(warehouse ?? "").trim().toLowerCase() ===
				(currentLocation ?? "").trim().toLowerCase()
		) {
			const cartLineItemQuantity = Number.parseInt(quantity);
			if (sku.includes("PRE-")) {
				existPreorderQuantity += cartLineItemQuantity;
			} else {
				existInstockQuantity += cartLineItemQuantity;
			}
		}
	}

	return { existInstockQuantity, existPreorderQuantity };
};

const calculateInputValues = (
	matchedVariantData,
	matchedPreorderVariantData,
	currentLocation,
	existInstockQuantity,
	existPreorderQuantity,
	quantityInput,
) => {
	let inputAvailableValue = 0;
	let inputMaxValue = 0;

	if (matchedVariantData) {
		const parsedLines = matchedVariantData
			.split(",")
			.map((s) => s.trim())
			.filter(Boolean);
		let qtyForWarehouse = 0;
		for (const locationData of parsedLines) {
			const parts = locationData.split("|").map((p) => p.trim());
			const [quantity, , warehouseRaw] = parts;
			const warehouse = warehouseRaw ?? "";
			if (warehouse.toLowerCase() === currentLocation) {
				qtyForWarehouse = Number.parseInt(quantity, 10);
			}
		}
		inputAvailableValue = Math.max(0, qtyForWarehouse - existInstockQuantity);
		quantityInput.setAttribute("data-available-qty", inputAvailableValue);
	} else {
		inputAvailableValue = 0;
		quantityInput.setAttribute("data-available-qty", 0);
	}

	if (matchedPreorderVariantData) {
		const parsedPreorderLines = matchedPreorderVariantData
			.split(",")
			.map((s) => s.trim())
			.filter(Boolean);
		for (const locationData of parsedPreorderLines) {
			const parts = locationData.split("|").map((p) => p.trim());
			const [quantity, , warehouseRaw] = parts;
			const warehouse = warehouseRaw ?? "";
			if (warehouse.toLowerCase() === currentLocation) {
				inputMaxValue += Number.parseInt(quantity, 10);
			}
		}
	}

	inputMaxValue += inputAvailableValue;
	inputMaxValue -= existPreorderQuantity;
	inputMaxValue = Math.max(0, inputMaxValue);
	quantityInput.setAttribute("max", inputMaxValue);

	return { inputAvailableValue, inputMaxValue };
};

const updateCartButtonState = (button, availableValue, maxValue) => {
	if (!button) return;

	const parent = button.parentElement;

	if (availableValue === 0 && maxValue > 0) {
		button.innerText = "Preorder";
		parent.removeAttribute("disabled");
	} else if (availableValue > 0) {
		button.innerText = "Add To Cart";
		parent.removeAttribute("disabled");
	} else if (availableValue === 0 && maxValue === 0) {
		button.innerText = "Sold Out";
		parent.setAttribute("disabled", "disabled");
	}
};
